import type { AiCostTotals } from "@nlc/shared-types";

import { formatMicroUsd } from "./formatUsd";

const formatCount = (value: number) => value.toLocaleString("en-US");

export function AiCostsTotals({ totals }: { totals: AiCostTotals }) {
  const items = [
    { label: "Total cost", value: formatMicroUsd(totals.costMicroUsd) },
    { label: "Events", value: formatCount(totals.events) },
    { label: "Failed", value: formatCount(totals.failedEvents) },
    {
      label: "Tokens (in / out)",
      value: `${formatCount(totals.inputTokens)} / ${formatCount(totals.outputTokens)}`,
    },
    { label: "Images", value: formatCount(totals.images) },
    { label: "Megapixels", value: formatCount(totals.megapixels) },
  ];

  return (
    <dl className="grid grid-cols-2 gap-4 sm:grid-cols-3 lg:grid-cols-6">
      {items.map(({ label, value }) => (
        <div
          className="rounded-md border border-border-primary px-5 py-4"
          key={label}
        >
          <dt className="text-sm text-text-tertiary">{label}</dt>
          <dd className="text-xl font-semibold text-text-primary">{value}</dd>
        </div>
      ))}
    </dl>
  );
}
